import React, { useState } from "react";
import { NavLink, Link, useHistory } from "react-router-dom";
import MyUrlmage from "./MyUrlmage";

function Nav() {
  const [search, setSearch] = useState({ search: "" })
  let name, value
  const handleInputs = (e) => {
    name = e.target.name
    value = e.target.value
    setSearch({ ...search, [name]: value })
  }
  const history = useHistory()
  const Searchinput = (e) => {
    e.preventDefault()
    history.push(`/search/${search.search.replace(/\//g, '').replace(/%/g, '').replace(/#/g, '')}`)
  }
  return (
    <>
      <nav style={{ userSelect: 'none' }} className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <button
          style={{ outline: 'none' }}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo03"
          aria-controls="navbarTogglerDemo03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <Link className="navbar-brand" style={{ fontSize: '20px', fontWeight: 'revert' }} to="/">
          <img className="rounded-circle" height="30px" width="30px" src={`${MyUrlmage}/media/images/icon.jpg`} alt=".." />
        </Link>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            {[{ name: 'Home', link: "/" }, { name: "Videos", link: "/videos" }, { name: "Watch On YouTube", link: "https://www.youtube.com/channel/UCxNpmV2gyok9bdtpMfQZj1A" }, { name: "Contact Us", link: "/contact" }].map((val, index) => {
              return (
                <li className="nav-item">
                  {val.link.charAt(0) !== 'h' ? <NavLink exact activeClassName="active nav_active" className="nav-link" to={val.link}>
                    {val.name}
                  </NavLink>
                    : <a target="_blank" className="nav-link" href={val.link} rel="noreferrer">
                      {val.name}
                  </a>}
                </li>
              )
            })}
          </ul>
          <form
            onSubmit={Searchinput}
            method="dialog"
            className="form-inline my-2 my-lg-0"
          >
            <input
              autoFocus
              name="search"
              type="text"
              id="myInput2"
              className="form-control mr-sm-2"
              spellCheck="false"
              placeholder="Search"
              autoComplete="off"
              value={search.search}
              onChange={handleInputs}
            />

            <button
              type="submit"
              className="btn btn-outline-success"
            >
              Search
            </button>
          </form>
        </div>
      </nav>
    </>
  );
}

export default Nav;
